var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoApam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 538.66669 538.66669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 404h404V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.3333333 0 0 -1.3333333 0 538.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-82.843-67.157-150-150-150S-300-82.843-300 0s67.157 150 150 150S0 82.843 0 0",
    style: {
      fill: "#46505b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(347.5 207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-1.392-6.091-2.61-9.57l-5.482-16.532H8.091L2.61-9.57C1.479-6.091.174 0 .174 0Zm10.875-35.237h-21.664l-5.22-15.835h-11.572L-5.83 10.702H5.916l21.751-61.774H16.096Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(106.168 232.5723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c6.525 0 10.354 4.177 10.354 10.615 0 6.352-3.829 10.441-10.18 10.441h-10.702V0Zm-21.751 30.714H2.088c11.572 0 19.663-8.092 19.663-20.099S13.66-9.744 2.088-9.744h-12.616v-21.317h-11.223z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(163.5005 212.5605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-1.393-6.091-2.61-9.57l-5.482-16.532H8.092L2.609-9.57C1.479-6.091.174 0 .174 0Zm10.876-35.237h-21.665l-5.22-15.835h-11.572L-5.83 10.702H5.916l21.752-61.774H16.096Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(213.1777 232.5723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12.007l12.094-30.539c1.391-3.654 3.131-9.049 3.131-9.049h.174s1.654 5.395 3.046 9.049L42.546 0h12.007l4.959-61.774H48.375l-2.61 34.541c-.261 4.089-.087 9.571-.087 9.571h-.174s-1.827-6.004-3.307-9.571L32.191-51.16H22.36l-9.919 23.927c-1.478 3.567-3.392 9.658-3.392 9.658h-.175s.175-5.569-.087-9.658l-2.61-34.541H-5.047Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(251.8906 243.2744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.063 1.826-1.197 2.709-2.562 2.709-1.553 0-2.813-.967-3.107-2.709Zm-2.52 4.325C.483 4.325 2.079 2.1 2.079-.65c0-.274-.063-.883-.063-.883h-7.748c.105-2.33 1.764-3.506 3.653-3.506 1.827 0 3.15 1.238 3.15 1.238l.84-1.49S.336-6.803-2.205-6.803c-3.338 0-5.627 2.414-5.627 5.565 0 3.38 2.289 5.563 5.312 5.563",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(97.2349 170.1133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s1.197-1.238 3.044-1.238c.882 0 1.764.462 1.764 1.322 0 1.953-5.459 1.555-5.459 5.019 0 1.931 1.722 3.023 3.842 3.023 2.331 0 3.423-1.176 3.423-1.176l-.819-1.532s-.945.944-2.625.944c-.881 0-1.742-.378-1.742-1.301 0-1.911 5.459-1.491 5.459-4.977 0-1.764-1.512-3.086-3.843-3.086-2.603 0-4.031 1.554-4.031 1.554z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(109.269 166.3125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.063 1.826-1.197 2.709-2.562 2.709-1.553 0-2.813-.967-3.107-2.709Zm-2.52 4.325C.483 4.325 2.079 2.1 2.079-.65c0-.274-.063-.883-.063-.883h-7.748c.105-2.33 1.764-3.506 3.653-3.506 1.827 0 3.15 1.238 3.15 1.238l.84-1.49S.336-6.803-2.205-6.803c-3.338 0-5.627 2.414-5.627 5.565 0 3.38 2.289 5.563 5.312 5.563",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(132.9976 170.1133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.974v-1.848c0-.44-.042-.798-.042-.798h.042C2.457-1.092 3.695.126 5.333.126c.273 0 .525-.042.525-.042v-2.016s-.273.064-.588.064c-1.302 0-2.499-.924-2.981-2.499-.189-.609-.252-1.26-.252-1.911v-4.346H0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(144.9058 174.1865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.667 0 3.989-1.554 3.989-1.554l-.966-1.427S1.89-1.764.084-1.764c-2.142 0-3.695-1.595-3.695-3.779 0-2.163 1.553-3.821 3.758-3.821 1.974 0 3.275 1.427 3.275 1.427l.819-1.49S2.771-11.128 0-11.128c-3.338 0-5.69 2.373-5.69 5.565C-5.69-2.415-3.338 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(165.002 174.4385)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.905 174.187h2.037v-10.624h-2.037zm-.021 4.199h2.058v-2.079h-2.058z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.354 6.719c.462.566.882.986.882.986v.043s-.336-.043-1.029-.043H.231v1.743h8.755V8.272L3.632 1.533C3.191.986 2.729.566 2.729.566V.525s.357.041 1.05.041h5.397v-1.742H0z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(190.707 164.7383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.691 174.187h2.036v-10.624h-2.036zm-.021 4.199h2.058v-2.079h-2.058z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.016 0 3.653 1.596 3.653 3.821 0 2.204-1.637 3.78-3.653 3.78-1.994 0-3.653-1.576-3.653-3.78C-3.653 1.596-1.994 0 0 0m0 9.364c3.17 0 5.732-2.331 5.732-5.543C5.732.588 3.17-1.764 0-1.764c-3.17 0-5.732 2.352-5.732 5.585 0 3.212 2.562 5.543 5.732 5.543",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(227.2246 165.0742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0s1.197-1.238 3.045-1.238c.883 0 1.764.462 1.764 1.322 0 1.953-5.459 1.555-5.459 5.019 0 1.931 1.722 3.023 3.841 3.023 2.332 0 3.424-1.176 3.424-1.176l-.82-1.532s-.943.944-2.623.944c-.883 0-1.744-.378-1.744-1.301 0-1.911 5.459-1.491 5.459-4.977 0-1.764-1.512-3.086-3.842-3.086-2.604 0-4.031 1.554-4.031 1.554z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(255.5957 166.3125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.68 0 3.064 1.387 3.064 3.801 0 2.309-1.238 3.801-3.002 3.801-1.595 0-3.066-1.114-3.066-3.823C-3.004 1.891-1.953 0 0 0m-4.977 9.134h1.87V8.23c0-.419-.043-.776-.043-.776h.043s.902 1.932 3.568 1.932c2.855 0 4.662-2.268 4.662-5.564 0-3.381-2.037-5.564-4.809-5.564C-2.016-1.742-2.939 0-2.939 0h-.043s.043-.377.043-.924v-4.765h-2.038z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(277.2051 165.0527)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.723 0 2.836 1.806 2.836 3.38v.336h-.525c-1.534 0-4.305-.105-4.305-2.016C-1.994.84-1.322 0 0 0m2.352 5.249h.462v.189c0 1.743-.986 2.331-2.33 2.331-1.638 0-2.961-1.03-2.961-1.03l-.839 1.491S-1.783 9.49.652 9.49c2.688 0 4.2-1.469 4.2-4.157v-6.719H2.961v1.008c0 .482.043.84.043.84h-.043s-.861-2.1-3.4-2.1c-1.829 0-3.612 1.114-3.612 3.234 0 3.507 4.619 3.653 6.403 3.653",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(295.3691 164.9482)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApam);
export default __webpack_public_path__ + "static/media/logo_APAM.a4e6a02083c38b1d830f63f53e371439.svg";
export { ForwardRef as ReactComponent };